<template>
  <div>
    <div class="nav_father">
      <div class="nav">
        <div class="logo">
          <router-link to="/">
            <img width="97px" height="50px" :src="this.logo" alt />
            <!-- <img src="../../assets/dashu/logo2.png" alt=""> -->
          </router-link>
        </div>
        <el-menu
          :default-active="activeIndex"
          :router="true"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          text-color="white"
          active-text-color="#76c3a2"
        >
          <el-menu-item index="/Ahome">{{home}}</el-menu-item>
          <el-submenu index="/Aservice">
            <template slot="title">{{service}}</template>
            <el-menu-item @click="routerdetails(600)">{{service1}}</el-menu-item>
            <el-menu-item @click="routerdetails(1000)">{{service2}}</el-menu-item>
            <el-menu-item @click="routerdetails(1400)">{{service3}}</el-menu-item>
            <el-menu-item @click="routerdetails(1800)">{{service4}}</el-menu-item>
          </el-submenu>
          <el-menu-item index="/Ainnovate">{{innovate}}</el-menu-item>
          <el-menu-item index="/Anew">{{news}}</el-menu-item>
          <el-menu-item>
            <a style="color:white;" href="https://en.treegroup-inc.com/#/">{{longpage}}</a>
          </el-menu-item>
          <el-menu-item index="/Aabout">{{about}}</el-menu-item>
          <el-menu-item index="/Ajoin">{{join}}</el-menu-item>
        </el-menu>
        <div class="CNEN" @click="selecnen()">
          <div :class=" ischinese=='cn' ? 'cn cnsele' : 'cn' ">CN</div>
          <div :class=" ischinese=='en' ? 'en ensele' : 'en' ">EN</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ["reload"],
  name: "Btnav",
  data() {
    return {
      activeIndex: "/Ahome",
      logo: "",
      topnum: "0",
      ischinese: "cn",
      home: "首页",
      service: "我们的服务",
      service1: "品牌代运管理",
      service2: "多模式渠道管理",
      service3: "供应链管理",
      service4: "数据管理",
      innovate: "创新",
      news: "新闻中心",
      longpage: "Brand up",
      about: "关于我们",
      join: "加入我们"
    };
  },
  methods: {
    showIcon() {
      // console.log(document.documentElement.scrollTop)
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    getList() {
      this.$http
        .post("/api/dashu/footer/footerList", {})
        .then(res => {
          // console.log(res)
          var code = res.data.code;
          if (code === 0) {
            this.logo = res.data.data.about.logo;
          }
        })
        .catch(function(error) {
          //  console.log(error);
        });
    },
    routerdetails(topnum) {
      this.$router.push({
        name: "Aservice",
        query: { topnum: topnum }
      });
    },
    selecnen() {
      if (this.ischinese == "cn") {
        this.ischinese = "en";
        window.localStorage.setItem("ischinese", "en");
        // this.$router.go(0);
        this.reload();
      } else if (this.ischinese == "en") {
        this.ischinese = "cn";
        window.localStorage.setItem("ischinese", "cn");
        // this.$router.go(0);
        this.reload();
      }
    }
  },
  created() {
    this.getList();
    this.activeIndex = this.$route.path;
    this.ischinese = window.localStorage.getItem("ischinese") || "cn";
    if (this.ischinese == "en") {
      this.home = "HomePage";
      this.service = "OurServices";
      this.service1 = "BrandTransportationManagement";
      this.service2 = "Multi-modeChannelManagement";
      this.service3 = "SupplyChainManagement";
      this.service4 = "DataManagement";
      this.innovate = "Innovation";
      this.news = "InformationCenter";
      this.longpage = "Brand up";
      this.about = "AboutUs";
      this.join = "JoinUs";
    }
  },
  mounted() {
    window.addEventListener("scroll", this.showIcon);
  }
};
</script>
<style scoped>
.active {
  color: rgb(247, 180, 31) !important;
}
.nav_father {
  width: 100%;
  margin: 0 auto;
  z-index: 10;
  font-size: 16px;
  border-bottom: 1px solid transparent;
  border-top: 5px solid transparent;
  /* border-top:5px solid #76c3a2; */
  /* box-sizing : padding-box; */
  /* padding: 0 18%;   */
  background: transparent;
  overflow: hidden;
}
.nav {
  min-width: 1200px;
  height: 50px;
  background-color: transparent;
  display: flex;
  justify-content: center;
}
.nav ul {
  width: 918px;
  display: flex;
  /* margin: 0px auto; */
  border-bottom: 0px solid white;
  background-color: transparent;
}
.nav ul li {
  list-style: none;
  height: 50px;
  font-weight: bolder;
  width: 148px;
  text-align: center;
}
.nav ul li a {
  text-decoration: none;
  font-size: 16px;
  color: gray;
}
.nav ul li:hover {
  cursor: pointer;
  background-color: transparent;
}
.logo {
  width: 100px;
  -o-object-fit: cover;
  object-fit: cover;
  float: left;
  margin-top: -14px;
  height: 48px;
  margin-top: 0px;
  justify-content: center;
}
.logoimg1 {
  width: 70%;
  height: 80%;
  object-fit: contain;
  text-decoration: none;
  margin: 7px 0 0 100px;
}
.CNEN {
  color: #76c3a2;
  border: 2px solid #76c3a2;
  background-color: transparent;
  width: 60px;
  height: 22px;
  border-radius: 30px;
  position: relative;
  cursor: pointer;
  margin: auto 0;
}
.cn {
  position: absolute;
  top: 0;
  left: 4px;
  line-height: 1.5;
}
.en {
  position: absolute;
  top: 0;
  right: 4px;
  line-height: 1.5;
}
.cnsele {
  color: white;
  background-color: #76c3a2;
  border-radius: 15px;
  width: 30px;
  height: 100%;
  text-align: center;
  left: 0;
  line-height: 1.5;
}
.ensele {
  color: white;
  background-color: #76c3a2;
  border-radius: 15px;
  width: 30px;
  height: 100%;
  text-align: center;
  line-height: 1.5;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dashu/nav.vue